import { createApiQueryHook, IApiQueryFunction, IPaginateable, mapPagination } from "../../utils/api";
import { OneOrManyFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { AnnouncementStatus, IAnnouncementList } from "../types";

export interface IAnnouncementListQueryParameters extends IPaginateable {
    adminView?: boolean;
    filters?: {
        status?: OneOrManyFilter<AnnouncementStatus>;
    };
}

export type IAnnouncementListQueryResult = IAnnouncementList;

const mapFilters = (filters: IAnnouncementListQueryParameters["filters"]) => {
    const { status } = filters ?? {};

    return { status };
};

export const announcementListQuery: IApiQueryFunction<IAnnouncementListQueryParameters> = ({
    adminView,
    filters,
    pagination,
}) => ({
    method: "GET",
    url: `/announcements${serialize(
        {
            ...mapPagination(pagination),
            ...mapFilters(filters),
            adminView: adminView ? 1 : undefined,
        },
        true,
    )}`,
});

export const useAnnouncementListQuery = createApiQueryHook<
    IAnnouncementListQueryParameters,
    IAnnouncementListQueryResult
>(announcementListQuery);
